<div class="w-full">
  <div class="w-full h-25rem splash-bg">
  </div>

  <div dir="auto" class="w-full flex flex-column floating-container align-items-center">

    <div class="lg:w-9 sm:w-12" style="width:100%;">
      <p-card styleClass="border-round-2xl shadow-5 p-0">
        <div class="layout-container">

          <div class="w-full flex flex-column gap-3" style="min-height: 65vh">
            <div class="w-full flex flex-column flex-grow-1 p-3">

              <div class="align-self-center px-3 mb-3">
                <span [style.font-family]="articlesService.fontFamily" class="text-black-alpha-90 font-bold text-4xl">{{articlesService.isEnglish?'Privacy Policy':'سياسة الخصوصية'}}</span>
              </div>

              <div [style.font-family]="articlesService.fontFamily" class="px-3 mt-3 text-lg line-height-3" [innerHTML]="articlesService.isEnglish?pr:arPr"></div>

            </div>
          </div>

        </div>
      </p-card>
    </div>


    <div class="w-full h-5rem p-4">
        <span [style.font-family]="articlesService.fontFamily"class="font-light">
          {{articlesService.isEnglish?'&copy;2024 Q-Lift Elevators. Designed and Developed by ':'© 2024 مصاعد كيو ليفت. تصميم وتطوير '}}</span>
      <a href="https://web.facebook.com/Pixadvfb" target="_blank" class="cursor-pointer text-primary font-medium">
        <span [style.font-family]="articlesService.fontFamily" class="font-light">PixADV</span>
      </a>
    </div>

  </div>

</div>
